import pluralize from 'pluralize'

import { useIsTrialAccount } from '@/modules/account'
import { useStatements } from '@/modules/projects'
import { isStatementNotDuplicated } from '@/modules/projects/status'
import { summarizeTrialRead } from '../../trial'

export const TrialReadLine = () => {
  const isTrial = useIsTrialAccount()
  const statements = useStatements().filter(isStatementNotDuplicated)
  const { pagesRead, pagesSent, statementsRead } =
    summarizeTrialRead(statements)

  if (!isTrial || pagesRead === 0 || pagesRead >= pagesSent) return null

  return (
    <p role="status" className="text-sm">
      Your trial extracted the first {pagesRead} of the {pagesSent} pages you
      sent: {statementsRead} complete {pluralize('statement', statementsRead)}.
      The rest is stored and is extracted when you upgrade.
    </p>
  )
}
